import { FC, useCallback } from 'react';
import classNames from 'classnames';
import { Button, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { FormattedMessage } from 'react-intl';
import AdvertListFilterControlsCss from '#srcCssModules/advert/list-filter/advert-list-filter-controls.module.scss';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const Toggle: FC = () => {
  const {
    isVisible,
    openDetail,
    hideDetail,
  } = useFilterContext();

  const handlerClick = useCallback(() => {
    if (isVisible) {
      hideDetail();
    } else {
      openDetail();
    }
  }, [hideDetail, isVisible, openDetail]);

  return (
    <Button
      variant={ButtonVariant.unstyled}
      additionalClassName={classNames(
        AdvertListFilterControlsCss.advertListFilterControls__action,
        AdvertListFilterControlsCss.advertListFilterControls__action_all,
      )}
      onClick={handlerClick}
      icon={{
        text: <AppSvgSpriteMonoIcon name="filter" size={18} />,
      }}
    >
      <FormattedMessage defaultMessage="All filter" />
    </Button>
  );
};

export { Toggle };
